import { Box, Slider, TextField, Typography } from "@mui/material";
import React from "react";
import { getColor } from "../../style/color/color";
import { StyledQuestionTypography } from "../../style/styleComponents/StyledFinancialDetails";
import { numberToWords } from "../../logic/NumberToWord";
import { formatToIndianCurrency } from "../../logic/CurrencyFormatter";
import { fonts } from "../../style/fonts/fonts";

const AmountSlider = ({ income, setIncome, question }) => {
  const handleSliderChange = (event, newValue) => {
    if (income) {
      setIncome(income);
    }
    setIncome(newValue);
  };

  const handleTextFieldChange = (event) => {
    const numericValue = event.target.value.replace(/[^0-9]/g, "");
    if (numericValue === "") {
      setIncome(0);
    } else {
      const value = parseInt(numericValue, 10);
      if (!isNaN(value)) {
        setIncome(value);
      }
    }
  };

  return (
    <Box>
      <StyledQuestionTypography
        sx={{
          color: getColor.NeutralDark700,
          fontSize: 16,
          fontFamily: fonts.manrope,
          fontWeight: "700",
          mt: "30px",
        }}
      >
        {question}
      </StyledQuestionTypography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          mt: 2,
        }}
      >
        <TextField
          value={formatToIndianCurrency(income)}
          onChange={handleTextFieldChange}
          type="tel"
          variant="standard"
          sx={{
            width: "100%",
            maxWidth: "300px",
            borderRadius: 3,
            border: "0.50px #505662 solid",
            textAlign: "center",
            p: "10px",
            mt: "20px",
            "& input": {
              textAlign: "center",
              fontWeight: "600",
            },
            "& .MuiInput-root::before": {
              display: "none",
            },
            "& .MuiInput-root::after": {
              display: "none",
            },
          }}
        />
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
            textTransform: "initial",
            mt: "10px",
            color: getColor.NeutralDark700,
          }}
        >
          {`Rupees ${numberToWords(income)}`}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: 10,
          borderRadius: 10,
        }}
      >
        <Slider
          value={Number(income) || 0}
          onChange={handleSliderChange}
          valueLabelDisplay="auto"
          min={100000}
          max={10000000}
          step={1000}
          sx={{
            width: "90%",
            p: 1,
            mt: "10px",
            mr: "10px",
            ml: "10px",
            color: getColor.ExtendedpalettesSummerSkySS800,
            "& .MuiSlider-thumb": {
              height: 24,
              width: 24,
              backgroundColor: "white",
              border: "2px solid currentColor",
              "&:hover": {
                boxShadow: "inherit",
              },
            },
            "& .MuiSlider-track": {
              height: 8,
              borderRadius: 4,
            },
            "& .MuiSlider-rail": {
              height: 8,
              borderRadius: 4,
              backgroundColor: "rgba(0, 0, 0, 0.10)",
            },
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: "35px",
          ml: "12px",
          mr: "12px",
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            color: getColor.Grey,
          }}
        >
          ₹1,00,000
        </Typography>

        <Typography
          sx={{
            fontSize: 12,
            color: getColor.Grey,
          }}
        >
          ₹1cr+
        </Typography>
      </Box>
    </Box>
  );
};

export default AmountSlider;
